export class SmeltingMaterialCost {
    constructor({
          id= null,
          planCode= ``,
          day= ``,
          locName= ``,
          shift='',
          furnaceName= ``,
          furnaceBatch= ``,
          materialName= ``,
          materialCode= ``,
          materialBatch= ``,
          moisture= ``,
          level= ``,
          wetWeight= ``,
          dryWeight= ``,
          consumeRate= ``,

      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.day = day;
      this.locName = locName;
      this.shift = shift;
      this.furnaceName = furnaceName;
      this.furnaceBatch = furnaceBatch;
      this.materialName = materialName;
      this.materialCode = materialCode;
      this.materialBatch = materialBatch;
      this.moisture = moisture;
      this.level = level;
      this.wetWeight = wetWeight;
      this.dryWeight = dryWeight;
      this.consumeRate = consumeRate;
    }
  }
  export function gridFields() {
    return Object.freeze([
        {
          key: 'planCode',
          label: 'lbl.basic.planCode',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },
        {
          key: 'shift',
          label: 'lbl.basic.shift',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        // {
        //   key: 'furnaceName',
        //   label: 'lbl.basic.furnaceName',
        //   sortable: true,
        //   form: {
        //     type: 'select',
        //     options: [
        //       {value:"default", text:"lbl.basic.select.one"},
        //       {value:"1", text:"opt.furnaceNumber1"},
        //       {value:"2", text:"opt.furnaceNumber2"},
        //       {value:"3", text:"opt.furnaceNumber3"},
        //       {value:"4", text:"opt.furnaceNumber4"},
        //       {value:"5", text:"opt.furnaceNumber5"},
        //       {value:"6", text:"opt.furnaceNumber6"},
        //     ]
        //   }
        // },
        // {
        //   key: 'furnaceBatch',
        //   label: 'lbl.basic.furnaceBatch',
        //   sortable: true,
        //   form: {
        //     type: 'input'
        //   }
        // },
        {
          key: 'materialName',
          label: 'lbl.basic.materialName',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'materialCode',
          label: 'lbl.basic.materialCode',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'materialBatch',
          label: 'lbl.basic.materialBatch',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'moisture',
          label: 'lbl.prd.execution.materialMoisture',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'level',
          label: 'lbl.prd.execution.materialLevel',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'wetWeight',
          label: 'lbl.prd.execution.wetWeight',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'dryWeight',
          label: 'lbl.prd.execution.dryWeight',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'consumeRate',
          label: 'lbl.prd.execution.consumeRate',
          sortable: false,
          form: {
            type: 'input'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new SmeltingMaterialCost()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.planCodeFilter',
    'filter.plantFilter',
    'filter.shiftFilter',
    'filter.startDayFilter',
    'filter.endDayFilter',
    'filter.materialFilter',
    'filter.furnaceName',
  ];
  export const filter = {
    'planCodeFilter': "",
    'plantFilter': "",
    'shiftFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
    'materialFilter': "",
    'furnaceNameFilter': "",
  };
